/*
 * Shared add-to-cart for the Silky Nights sections.
 * Uses the theme's own <cart-drawer>: we ask /cart/add.js to return the
 * drawer + bubble section HTML, then hand it to renderContents(), which
 * re-renders and opens the drawer. Falls back to /cart if the drawer is absent
 * (e.g. cart_type set to "page").
 */
window.SNCart = (function () {
  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionsToRequest(d) {
    if (!d || typeof d.getSectionsToRender !== 'function') return [];
    return d.getSectionsToRender().map((s) => s.section || s.id);
  }

  function add(items, opts) {
    const options = opts || {};
    const d = drawer();
    const sections = sectionsToRequest(d);

    const body = { items: items };
    if (sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body),
    })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data: data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error((data && data.description) || 'add failed');

        if (d && data.sections && typeof d.renderContents === 'function') {
          // renderContents also opens the drawer.
          d.renderContents(data);

          // The host element's is-empty class is server-rendered and goes stale
          // after an AJAX add, which leaves the empty-cart styling in place.
          d.classList.remove('is-empty');
          const inner = d.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
        } else {
          window.location.href = '/cart';
          return data;
        }

        document.dispatchEvent(new CustomEvent('sn:cart:added', { detail: data }));
        return data;
      })
      .catch((err) => {
        if (options.fallbackUrl) window.location.href = options.fallbackUrl;
        else window.location.href = '/cart';
        throw err;
      });
  }

  return { add: add };
})();
